import { useCallback } from 'react'

import { useAuth } from '@sputnik/auth'

import { useGetApplicationEmailsLazyQuery } from './GetApplicationEmails.gql'
import { UseApplicationCollaboratorsParams } from './types'
import { getAllCollaborators, getCollaboratorsOnCreditApplication } from './utils'

export const useApplicationCollaboratorsLazy = ({ salesforceCreditId }: UseApplicationCollaboratorsParams) => {
  const { email } = useAuth()

  const [getApplicationCollaboratorsQuery] = useGetApplicationEmailsLazyQuery({
    variables: {
      creditApplicationId: salesforceCreditId,
    },
  })

  const getApplicationCollaborators = useCallback(async () => {
    if (!email) {
      return []
    }

    const { data, error } = await getApplicationCollaboratorsQuery()
    if (error || !data?.creditApplication) {
      return []
    }

    const collaboratorsOnCreditApplication = getCollaboratorsOnCreditApplication(data.creditApplication)

    const allCollaborators = getAllCollaborators({
      collaboratorsOnCreditApplication,
      email: '',
      creditApplication: data.creditApplication,
    })

    return allCollaborators
  }, [email, getApplicationCollaboratorsQuery])

  return { getApplicationCollaborators }
}
